import { API_BASE } from '../utils/constants';

// ─── Internal fetch wrapper ────────────────────────────────────────────────────

/**
 * Thin wrapper around fetch that:
 *   - Prepends API_BASE to relative paths
 *   - Throws a descriptive Error on non-ok responses
 *   - Returns parsed JSON
 *
 * @param {string} path     - e.g. '/videos' or '/categories'
 * @param {RequestInit} [options]
 * @returns {Promise<any>}
 */
async function apiFetch(path, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, options);
  if (!response.ok) {
    throw new Error(`API ${response.status}: ${path}`);
  }
  return response.json();
}

// ─── Branding ─────────────────────────────────────────────────────────────────

export const getBranding = () =>
  apiFetch('/branding').catch(() => null);

// ─── Categories ───────────────────────────────────────────────────────────────

export const getCategories = () =>
  apiFetch('/categories').catch(() => []);

// ─── Videos ───────────────────────────────────────────────────────────────────

export const getVideos = (category) => {
  const qs = category && category !== 'all'
    ? `?category=${encodeURIComponent(category)}`
    : '';
  return apiFetch(`/videos${qs}`);
};

export const getVideo = (id) =>
  apiFetch(`/videos/${id}`);

export const recordView = (id) =>
  fetch(`${API_BASE}/videos/${id}/view`, { method: 'POST' }).catch(() => {});

export const getRelatedVideos = (currentId, limit = 6) =>
  apiFetch(`/videos?limit=${limit}`)
    .then(data =>
      Array.isArray(data)
        ? data.filter(v => String(v.id) !== String(currentId)).slice(0, limit - 1)
        : []
    )
    .catch(() => []);

// ─── Likes ────────────────────────────────────────────────────────────────────

export const getLikeStatus = (videoId) =>
  apiFetch(`/likes/${videoId}`).catch(() => ({ liked: false }));

export const toggleVideoLike = (videoId) =>
  apiFetch(`/likes/${videoId}/toggle`, { method: 'POST' });
